import React, {useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {sendEvarData, logPageLoadEvents} from '@ibibo/analytics';
import {
  submitOtp,
  getMobileOtp,
  login,
  setAgentData,
  updateSid,
  setAgentDataNew,
} from '../../../../../store/actions/thunk';
import {
  setter,
  removeItem,
} from '../../../../../../../../common/client-side-storage/src/client-side-storage.web';
import {
  ACCOUNT_CREATED_PAGE_URL,
  ACCOUNT_MANUAL_PAGE_URL,
  AGENCY_DETAILS_NEW_URL,
  CREATE_PASSWORD_PAGE_URL,
  DOCUMENT_UPLOAD_KYC_URL,
  LICENSE_UPLOAD_URL,
  LOGIN_WITH_MMT_PASSWORD_URL,
  TERMS_CONDITIONS_PAGE_URL,
  VERIFY_OTP_NEW_URL,
} from '../../../../../constants/index';
import {
  tokenSelector,
  emailSelector,
  errorSelector,
  headingSelector,
  existingUserSelector,
} from '../../../../../store/selectors';

import {
  redirectToSameWindowWithoutRefresh,
  getUrlWithCrid,
  getCrid,
} from '../../../../../../../myaccount/src/utils/redirectWithCrId';

import BackButton from '../../GccComponents/BackButton/BackButton';
import OtpField from '../../GccComponents/OtpField/OtpField';
import CreateAccount from '../../GccComponents/CreateAccount/CreateAccount';
import InfoIcon from '../../GccComponents/assets/infoIcon.png';

import * as S from './VerifyEmailGcc.styles';
import * as C from '../../Common.styles';

const VerifyEmailGcc = ({showBackButtonFlag}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const deviceWidth = window.screen.width;
  const token = useSelector(tokenSelector);
  const registeredEmail = useSelector(emailSelector);
  const error = useSelector(errorSelector);
  const winSize = window.screen.width;
  const headingData = useSelector(headingSelector);
  const existingNumber = useSelector(existingUserSelector);

  let userUrl = window.location.search;
  let newUrl = userUrl.substring(1);
  let docRef = document.referrer;

  const [isVerified, setIsVerified] = useState(false);
  const [showAccountCreatePopup, setShowAccountCreatePopup] = useState(false);
  const [verifyEmailModal, setVerifyEmailModal] = useState(false);
  const [createAccountModal, setCreateAccountModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [disableResendOtp, setDeisableResendOtp] = useState(true);

  useEffect(() => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:otpvalidation|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/otpverify',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
    });
  }, []);

  useEffect(() => {
    let isMount = true;
    const handler = setTimeout(() => {
      if (isMount) {
        setDeisableResendOtp(false);
      }
    }, 15000);
    return () => {
      clearTimeout(handler);
      isMount = false;
    };
  }, [disableResendOtp]);

  useEffect(() => {
    if (error?.msg) {
      setShowLoader(false);
    }
  }, [error]);

  const handleChange = otp => {
    if (otp.length === 6) {
      setShowLoader(true);
      let fd = new FormData();
      fd.append('email_otp', otp);
      fd.append('email', registeredEmail);
      // fd.append('email_otp', data.email_otp);
      fd.append('token', token);
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:otpvalidation|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/otpverify',
        prop54: 'myPartner_onboarding_continue',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      });
      if (!existingNumber) dispatch(submitOtp(fd, successCallback));
      else {
        fd.append('username', registeredEmail);
        fd.delete('email_otp');
        fd.append('mobile_otp', otp);
        if (deviceWidth < 1024) {
          fd.append('dt', 'false');
        } else {
          fd.append('dt', 'true');
        }
        fd.append('referrer', userUrl === '' ? docRef : newUrl);
        dispatch(login(fd, sendOTPSuccessCallback, errorCallback));
      }
    }
  };

  const sendOTPSuccessCallback = resp => {
    //setSendOTPResponse(resp);
    if (resp.data.status && resp.data.token) {
      dispatch(setAgentDataNew(resp.data.token, successSetAgentData, errorSetAgentData));
    }
    function successUpdateCallback(status) {
      if (resp.mmt_auth) {
        setter('myPartnerAuth', {mmt_auth: resp.mmt_auth});
        setter('experiment', {experiment: resp.experiment});
      }
      if (resp.redirect_url) {
        window.open(resp.redirect_url, '_self');
      } else {
        // window.open('/hotels/', '_self');
      }
    }

    dispatch(updateSid(resp, successUpdateCallback, false));
  };

  const errorCallback = error => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:otpvalidation|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/otpverify',
      prop22: 'myPartner_onboarding_invalidOTP',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
    });
  };

  const successSetAgentData = () => {
    history.push(`${VERIFY_OTP_NEW_URL}?crId=${getCrid()}`);
  };

  const errorSetAgentData = () => {};

  const handleVerifyModal = () => setVerifyEmailModal(!verifyEmailModal);
  const handleCreateAccountModal = () => setCreateAccountModal(!createAccountModal);
  const onBackPress = () => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:otpvalidation|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/otpverify',
      prop54: 'myPartner_onboarding_back',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
    });
    history.goBack();
  };

  const successCallback = screen => {
    setShowAccountCreatePopup(true);
    switch (screen) {
      case 'details':
        history.push(`${LICENSE_UPLOAD_URL}?crId=${getCrid()}`);
        break;
      case 'kyc_doc':
        history.push(`${DOCUMENT_UPLOAD_KYC_URL}?crId=${getCrid()}`);
        break;
      case 'create_password':
        history.push(`${CREATE_PASSWORD_PAGE_URL}?crId=${getCrid()}`);
        break;
      case 'mmt_password':
        history.push(`${LOGIN_WITH_MMT_PASSWORD_URL}?crId=${getCrid()}`);
        break;
      case 'tnc':
        history.push(`${TERMS_CONDITIONS_PAGE_URL}?crId=${getCrid()}`);
        break;
      case 'verification':
        history.push(`${ACCOUNT_CREATED_PAGE_URL}?crId=${getCrid()}`);
        break;
      case 'manual':
        history.push(`${ACCOUNT_MANUAL_PAGE_URL}?crId=${getCrid()}`);
        break;
      default:
        history.push(`${AGENCY_DETAILS_NEW_URL}?crId=${getCrid()}`);
        break;
    }
  };

  const resendOtp = () => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:otpvalidation|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/otpverify',
      prop54: 'myPartner_onboarding_resendOTP',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
    });
    const data = {
      email: registeredEmail,
    };
    let fd = new FormData();

    for (const key in data) {
      fd.append(key, data[key]);
    }
    dispatch(getMobileOtp(data, fd, successCallbackOtpResend));
  };

  const successCallbackOtpResend = data => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:otpvalidation|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/otpverify',
      prop54: 'myPartner_onboarding_resendOTP',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
    });
  };

  return showAccountCreatePopup ? (
    <CreateAccount />
  ) : (
    <S.VrfyEmail>
      {showBackButtonFlag && (
        <S.VrfyEmailHdr>
          {winSize <= 767 ? (
            <BackButton onBackPress={onBackPress} text="CLOSE" arrow={true} />
          ) : (
            <BackButton onBackPress={onBackPress} arrow={true} />
          )}
        </S.VrfyEmailHdr>
      )}
      <S.Heading>
        <span>
          <img src={InfoIcon} alt="" />
        </span>
        Verify email using OTP
      </S.Heading>
      <S.SubHeading>
        We've e-mailed you a 6 digit code. Please check your email: <span>{registeredEmail}</span>{' '}
        and enter the code here to complete the verification
      </S.SubHeading>
      <S.Content>
        <OtpField
          labelText="Enter OTP"
          resendOtp="Resend OTP"
          onChange={handleChange}
          showLoader={showLoader}
          resendOtpCaller={resendOtp}
          disableResendOtp={disableResendOtp}
        />
      </S.Content>
      <S.Edit onClick={onBackPress}>Edit Email</S.Edit>
      {error?.msg && <S.ErrorMsg>{error?.msg}</S.ErrorMsg>}
      {/* {<S.FooterText>
        Not able to receive OTP ? Verify later by clicking{' '}
        <a className="latoBold" href="#">
          here
        </a>
      </S.FooterText>} */}
    </S.VrfyEmail>
  );
};

export default VerifyEmailGcc;
